"use client";

import { useQuery } from "@tanstack/react-query";

import type { EnvironmentInfo } from "@/app/api/environment/route";

async function fetchEnvironmentInfo(): Promise<EnvironmentInfo> {
  const response = await fetch("/api/environment", {
    method: "GET",
    headers: { accept: "application/json" },
    cache: "no-store",
  });
  if (!response.ok) {
    return { environment: null };
  }
  return (await response.json()) as EnvironmentInfo;
}

export function useEnvironmentInfo() {
  return useQuery({
    queryKey: ["environmentInfo"],
    queryFn: fetchEnvironmentInfo,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
    retry: 0,
  });
}
